import '../sass/smartbanner.sass';

interface BannerConfig {
    appScheme: string;
    appId: string;
    appleAppId: string;
    timeoutMs: number;
}

const config: BannerConfig = {
    appScheme: "sooner://",
    appId: "fr.noop.app.ucfr",
    appleAppId: "1532902092",
    timeoutMs: 1500
};

export function initSmartBanner(): void {
    const banner = document.getElementById('smart-banner');
    const btnDownload = document.getElementById('btn-download') as HTMLAnchorElement;
    const textnDownload = document.getElementById('text-download') as HTMLAnchorElement;
    const btnOpen = document.getElementById('btn-open') as HTMLAnchorElement;
    const textOpen = document.getElementById('text-open') as HTMLAnchorElement;
    const btnClose = document.querySelector('.btn-close') as HTMLButtonElement;

    if (!banner || !btnDownload || !btnOpen || !btnClose) {
        console.warn('Smart Banner: Required HTML elements not found.');
        return;
    }

    if (localStorage.getItem('banner_closed') === 'true') {
        return;
    }

    const ua = navigator.userAgent;
    const isMobile = /Android|iPhone|iPad|iPod/i.test(ua);

    if (!isMobile) return;

    // Determine Store Links
    const isIOS = /iPhone|iPad|iPod/i.test(ua);
    const isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent) && /Version\/\d+.*Safari/.test(navigator.userAgent);
    const storeLink = isIOS
        ? `https://apps.apple.com/app/id${config.appleAppId}`
        : `https://play.google.com/store/apps/details?id=${config.appId}`;

    if (!isIOS || !isSafari) {
        // Show Banner
        banner.classList.add('is-visible');

        // Probe Logic
        const start = Date.now();
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = config.appScheme;
        document.body.appendChild(iframe);

        const checkInstallation = (): void => {
            const elapsed = Date.now() - start;
            const hasFocus = document.hasFocus();

            if (hasFocus && elapsed >= config.timeoutMs) {
                // App NOT installed
                btnDownload.href = storeLink;
                btnDownload.classList.add('is-visible');
                textnDownload?.classList.add('is-visible');
                btnOpen.classList.remove('is-visible');
                textOpen?.classList.remove('is-visible');
            } else {
                // App likely installed
                btnOpen.href = config.appScheme;
                btnOpen.classList.add('is-visible');
                textOpen?.classList.add('is-visible');
                btnDownload.classList.remove('is-visible');
                textnDownload?.classList.remove('is-visible');
            }

            if (document.body.contains(iframe)) {
                document.body.removeChild(iframe);
            }
        };

        setTimeout(checkInstallation, config.timeoutMs);

        btnClose.addEventListener('click', () => {
            banner.classList.remove('is-visible');
            localStorage.setItem('banner_closed', 'true');
        });
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmartBanner);
} else {
    initSmartBanner();
}
